import {useState} from "react";
import TabMenu from "../../components/TabMenu/TabMenu.tsx";
import StrategicInitiative from "./StrategicInitiative.tsx";
import SprintProfile from "./SprintProfile.tsx";
import SprintDrivers from "./SprintDrivers.tsx";
import StrategyAlignment from "./StrategyAlignment.tsx";
import Readiness from "./Readiness.tsx";
import Activation from "./Activation.tsx";
import FilterClients from "../../components/FilterClients/FilterClients.tsx";


export default function SprintMenu() {
  const [tab, setTab] = useState(0);

  const tabs = [
    {title: "Readiness", callback: () => setTab(0)},
    {title: "Strategic Initiative", callback: () => setTab(1)},
    {title: "Organisational states", callback: () => setTab(2)},
    {title: "Strategic alignment", callback: () => setTab(3)},
    {title: "Activation data", callback: () => setTab(4)},
    {title: "Profile data", callback: () => setTab(5)},
  ]

  const renderTab = () => {
    if (tab === 0) {
      return <Readiness/>;
    } else if (tab === 1) {
      return <StrategicInitiative/>;
    } else if (tab === 2) {
      return <SprintDrivers />;
    } else if (tab === 3) {
      return <StrategyAlignment />;
    } else if (tab === 4) {
      return <Activation />;
    } else if (tab === 5) {
      return <SprintProfile />;
    } else {
      return (
        <div>Working on it - calm down</div>
      )
    }
  }


  return (
    <div className="main-wide">
      <FilterClients/>
      <div className="my-6 mx-8">
        <TabMenu items={tabs} active={tab} type="buttons"/>
      </div>

      <div className="content-wide px-8 py-4">
        {renderTab()}
      </div>
    </div>
  );
}